import { render, staticRenderFns } from "./ZertifikatAuswahlModal.vue?vue&type=template&id=603b8afd"
import script from "./ZertifikatAuswahlModal.vue?vue&type=script&lang=js"
export * from "./ZertifikatAuswahlModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports